module.exports = __webpack_public_path__ + "static/media/29EUNOG4.9aa33dfa.jpg";